/**
 * @generated SignedSource<<45af7a33254afe674864c396f87ac0d2>>
 * @relayHash 63fd75032fa3f9112c9f1e1c21394717
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f425c5e84e5ae3be9c4a6c8cbdcbea20d9d2824721d880485bb79752791e8f80

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ClassificationLevelSource = "AUTO" | "CONTENT" | "NONE" | "ORGANIZATION" | "SPACE" | "%future added value";
export type ConfluenceShareableLinkAccessType = "EXTERNAL" | "INTERNAL_LICENSED" | "%future added value";
export type ContentStateRestrictionLevel = "NONE" | "PAGE_OWNER" | "%future added value";
export type DataSecurityPolicyAction = "AI_ACCESS" | "ANONYMOUS_ACCESS" | "APP_ACCESS" | "APP_ACCESS_CONFIGURED" | "ATTACHMENT_DOWNLOAD" | "MCP_ACCESS" | "PAGE_EXPORT" | "PUBLIC_LINKS" | "%future added value";
export type KnowledgeDiscoveryKeyPhraseCategory = "ACRONYM" | "AUTO" | "OTHER" | "PROJECT" | "TEAM" | "%future added value";
export type PublicLinkPageStatus = "BLOCKED_BY_CLASSIFICATION_LEVEL" | "BLOCKED_BY_CONTAINER_POLICY" | "BLOCKED_BY_ORG" | "BLOCKED_BY_ORG_DEFAULT_POLICY" | "BLOCKED_BY_PRODUCT" | "BLOCKED_BY_SPACE" | "OFF" | "ON" | "SITE_BLOCKED" | "SITE_DISABLED" | "SPACE_BLOCKED" | "SPACE_DISABLED" | "TRASHED" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type ContentBlogUnifiedQuery$variables = {
  autohighlightsEntityAri?: string | null;
  autohighlightsWorkspaceId?: string | null;
  bylineContributorsLimit?: number | null;
  contentId: string;
  includeAgentTrustReceiptData?: boolean | null;
  includeAnalyticsByline?: boolean | null;
  includeAudioContent?: boolean | null;
  includeAutohighlights?: boolean | null;
  includeAutomationDiscoveries?: boolean | null;
  includeBylineContributors?: boolean | null;
  includeClassification?: boolean | null;
  includeContentHeader?: boolean | null;
  includeContentHeaderAccess?: boolean | null;
  includeContentHeaderPublicLink?: boolean | null;
  includeFabricEditorEligibility?: boolean | null;
  includeReactions?: boolean | null;
  includeRendererAssetsCustomChrome?: boolean | null;
  includeRendererAssetsDsp?: boolean | null;
  includeRendererAssetsMedia?: boolean | null;
  includeRestrictionAncestors?: boolean | null;
  includeRestrictions?: boolean | null;
  isSSR?: boolean | null;
  preloadLabels?: boolean | null;
  rendererAssetsDspAction?: DataSecurityPolicyAction | null;
  spaceKey?: string | null;
  useClassificationLevelV2?: boolean | null;
  useContentModeFragment?: boolean | null;
  useNewContentTopper?: boolean | null;
  versionOverride?: number | null;
};
export type ContentBlogUnifiedQuery$data = {
  readonly analyticsBylineFragment?: {
    readonly " $fragmentSpreads": FragmentRefs<"AnalyticsByLine_query">;
  } | null;
  readonly autohighlightsQueryFragment?: {
    readonly " $fragmentSpreads": FragmentRefs<"preloadAutohighlightsQuery_query">;
  } | null;
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly appearancePublished: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly archivedPageBannerStatusFragment: {
        readonly " $fragmentSpreads": FragmentRefs<"ArchivedPageBannerV2Status_content">;
      };
      readonly audioContent?: {
        readonly audioProperties: {
          readonly nodes: ReadonlyArray<{
            readonly key: string | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
        readonly emoji: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
        readonly history: {
          readonly createdBy: {
            readonly displayName: string | null;
            readonly profilePicture: {
              readonly path: string;
            } | null;
          } | null;
          readonly ownedBy: {
            readonly displayName: string | null;
            readonly profilePicture: {
              readonly path: string;
            } | null;
          } | null;
        } | null;
        readonly id: string | null;
        readonly links: {
          readonly base: string | null;
          readonly webui: string | null;
        } | null;
        readonly subType: string | null;
        readonly title: string | null;
      } | null;
      readonly audioContentFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"AudioContentFragment_content">;
      } | null;
      readonly body: {
        readonly dynamic: {
          readonly content: {
            readonly id: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null;
          readonly representation: string | null;
          readonly value: string | null;
          readonly webresource: {
            readonly superbatch: {
              readonly tags: {
                readonly css: string | null;
                readonly js: string | null;
              } | null;
            } | null;
            readonly tags: {
              readonly css: string | null;
              readonly js: string | null;
            } | null;
          } | null;
        } | null;
      } | null;
      readonly bylineClassificationFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"BylineClassification_content">;
      } | null;
      readonly commentsPanelPermission: {
        readonly " $fragmentSpreads": FragmentRefs<"ViewPageCommentsPanelPermission_content">;
      };
      readonly contentClassificationFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"useContentClassification_content">;
      } | null;
      readonly contentHeaderFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"ContentHeader_content">;
      } | null;
      readonly contentProperties: {
        readonly draft: {
          readonly contentMode: string | null;
        } | null;
        readonly latest: {
          readonly contentMode: string | null;
          readonly generatedBy?: string | null;
        } | null;
      } | null;
      readonly contentState: {
        readonly color: string;
        readonly id: string | null;
        readonly name: string;
        readonly restrictionLevel: ContentStateRestrictionLevel;
      } | null;
      readonly contentStateLastUpdated: {
        readonly value: string;
      } | null;
      readonly contentTitleWithByLine?: {
        readonly " $fragmentSpreads": FragmentRefs<"ContentTitleWithByLine_content">;
      } | null;
      readonly coverPicture?: {
        readonly coverPictureProperties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly id: string | null;
      } | null;
      readonly draftVersion: {
        readonly by: {
          readonly displayName: string | null;
        } | null;
        readonly contentTypeModified: boolean | null;
        readonly friendlyWhen: string | null;
        readonly number: number | null;
        readonly when: string | null;
      } | null;
      readonly history?: {
        readonly createdBy: {
          readonly displayName: string | null;
        } | null;
        readonly createdDate: string | null;
      } | null;
      readonly id: string | null;
      readonly labels?: {
        readonly count: number | null;
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly label: string | null;
          readonly name: string | null;
          readonly prefix: string | null;
        } | null> | null;
      } | null;
      readonly meetingNotesAutomationDiscoveryFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"MeetingNotesAutomationDiscoveryFragment_content">;
      } | null;
      readonly metadata: {
        readonly frontend: {
          readonly collabService: string | null;
          readonly coverPictureWidth?: string | null;
          readonly embedded: boolean;
          readonly fabricEditorSupported: boolean | null;
        } | null;
        readonly lastModifiedDate: string | null;
      };
      readonly operations: ReadonlyArray<{
        readonly operation: string | null;
        readonly targetType: string | null;
      } | null> | null;
      readonly pageContentRendererFragment: {
        readonly " $fragmentSpreads": FragmentRefs<"PageContentRenderer_content">;
      };
      readonly pageRestrictionsContext?: {
        readonly hasInheritedRestrictions: boolean;
        readonly hasRestrictions: boolean;
        readonly hasViewRestrictions: boolean;
        readonly id: string | null;
      } | null;
      readonly pageRestrictionsContextAncestors?: {
        readonly ancestors: ReadonlyArray<{
          readonly hasRestrictions: boolean;
          readonly id: string | null;
          readonly links: {
            readonly webui: string | null;
          } | null;
          readonly title: string | null;
        } | null> | null;
        readonly id: string | null;
      } | null;
      readonly pageTitlePublished?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly reactionsContent?: {
        readonly contentReactionsSummary: {
          readonly ari: string;
          readonly containerAri: string;
          readonly reactionsCount: number;
          readonly reactionsSummaryForEmoji: ReadonlyArray<{
            readonly count: number;
            readonly emojiId: string;
            readonly id: string;
            readonly reacted: boolean;
          } | null>;
        } | null;
        readonly id: string | null;
      } | null;
      readonly reactionsContentFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"ReactionsContentFragment_content">;
      } | null;
      readonly rendererAssetsMacroOutput?: {
        readonly " $fragmentSpreads": FragmentRefs<"ViewPageExtensionsAndRendererAssetsContentFragment_content">;
      } | null;
      readonly rendererAssetsMedia?: {
        readonly " $fragmentSpreads": FragmentRefs<"ViewPageExtensionsAndRendererAssetsContentFragment_mediaContent">;
      } | null;
      readonly rendererCoverPicture?: {
        readonly " $fragmentSpreads": FragmentRefs<"CoverPictureQuery_content">;
      } | null;
      readonly rendererTitleContentProperties?: {
        readonly " $fragmentSpreads": FragmentRefs<"useTitleContentPropertiesForPublishedPage_content">;
      } | null;
      readonly shareAndRestrictButtonData?: {
        readonly hasInheritedRestrictions: boolean;
        readonly hasRestrictions: boolean;
        readonly hasViewRestrictions: boolean;
        readonly id: string | null;
        readonly title: string | null;
      } | null;
      readonly smartFolderProperties: {
        readonly nodes: ReadonlyArray<{
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly space: {
        readonly alias: string | null;
        readonly id: string | null;
        readonly key: string | null;
        readonly name: string | null;
      } | null;
      readonly status: string | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly titleContentProperties?: {
        readonly id: string | null;
        readonly metadata: {
          readonly frontend: {
            readonly coverPictureWidth: string | null;
          } | null;
        };
        readonly pageTitleDraft: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly pageTitlePublished: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
      readonly type: string | null;
      readonly version: {
        readonly by: {
          readonly displayName: string | null;
        } | null;
        readonly confRev: string | null;
        readonly contentTypeModified: boolean | null;
        readonly friendlyWhen: string | null;
        readonly number: number | null;
        readonly when: string | null;
      } | null;
      readonly viewPageContentMode?: {
        readonly " $fragmentSpreads": FragmentRefs<"ContentModeFragmentProvider_content">;
      } | null;
      readonly viewPageLabels?: {
        readonly " $fragmentSpreads": FragmentRefs<"ViewPageLabelsContentFragment_content">;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"PageStatusQueryRelaySpike_content" | "PresenterModePortal_content">;
    } | null> | null;
  } | null;
  readonly contentContributors?: {
    readonly isCurrentUserContributor: boolean | null;
    readonly " $fragmentSpreads": FragmentRefs<"ByLineContributors_contentContributors" | "NudgeContributorFilter_contentContributors" | "PageHeaderLoomButton_contentContributors" | "SmartsFeedbackComponent_contentContributors">;
  } | null;
  readonly dataSecurityPolicy?: {
    readonly isActionEnabledForContent: {
      readonly action: DataSecurityPolicyAction | null;
      readonly allowed: boolean | null;
    };
  } | null;
  readonly mediaConfiguration?: {
    readonly clientId: string;
    readonly fileStoreUrl: string;
  } | null;
  readonly publicLinkPage?: {
    readonly accessType: ConfluenceShareableLinkAccessType | null;
    readonly pageId: string;
    readonly pageStatus: PublicLinkPageStatus;
  } | null;
  readonly space: {
    readonly contentHeaderFragment?: {
      readonly " $fragmentSpreads": FragmentRefs<"ContentHeader_space">;
    } | null;
    readonly currentUser: {
      readonly isAnonymouslyAuthorized: boolean;
    };
    readonly id: string | null;
    readonly lookAndFeel: {
      readonly content: {
        readonly container: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly borderRadius: string | null;
          readonly padding: string | null;
        } | null;
        readonly screen: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly gutterBottom: string | null;
          readonly gutterLeft: string | null;
          readonly gutterRight: string | null;
          readonly gutterTop: string | null;
          readonly layer: {
            readonly background: string | null;
            readonly backgroundAttachment: string | null;
            readonly backgroundBlendMode: string | null;
            readonly backgroundClip: string | null;
            readonly backgroundColor: string | null;
            readonly backgroundImage: string | null;
            readonly backgroundOrigin: string | null;
            readonly backgroundPosition: string | null;
            readonly backgroundRepeat: string | null;
            readonly backgroundSize: string | null;
            readonly height: string | null;
            readonly width: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
    readonly pageContentRendererFragment: {
      readonly " $fragmentSpreads": FragmentRefs<"PageContentRenderer_space">;
    };
    readonly settings: {
      readonly customHeaderAndFooter: {
        readonly footer: {
          readonly css: string;
          readonly html: string;
          readonly js: ReadonlyArray<string | null>;
          readonly spaUnfriendlyMacros: ReadonlyArray<{
            readonly name: string | null;
          }>;
        };
        readonly header: {
          readonly css: string;
          readonly html: string;
          readonly js: ReadonlyArray<string | null>;
          readonly spaUnfriendlyMacros: ReadonlyArray<{
            readonly name: string | null;
          }>;
        };
      };
      readonly routeOverrideEnabled?: boolean | null;
    } | null;
    readonly theme: {
      readonly name: string | null;
      readonly themeKey: string | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ContentContainerTheme_space" | "ContentTitle_space">;
  } | null;
};
export type ContentBlogUnifiedQuery$rawResponse = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly ancestors?: ReadonlyArray<{
        readonly hasRestrictions: boolean;
        readonly id: string | null;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly title: string | null;
      } | null> | null;
      readonly appearancePublished: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly audioProperties?: {
        readonly nodes: ReadonlyArray<{
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly body: {
        readonly atlas_doc_format?: {
          readonly mediaToken: {
            readonly token: string | null;
          } | null;
        } | null;
        readonly dynamic: {
          readonly content: {
            readonly id: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null;
          readonly representation: string | null;
          readonly value: string | null;
          readonly webresource: {
            readonly superbatch: {
              readonly tags: {
                readonly css: string | null;
                readonly js: string | null;
              } | null;
            } | null;
            readonly tags: {
              readonly css: string | null;
              readonly js: string | null;
            } | null;
          } | null;
        } | null;
      } | null;
      readonly classificationLevelDetails?: {
        readonly canManageSpaceSettings: boolean;
        readonly classificationControlSetting: string | null;
        readonly classificationLevel?: {
          readonly color: string | null;
          readonly description: string | null;
          readonly guideline: string | null;
          readonly guidelineADF: string | null;
          readonly id: string;
          readonly name: string;
          readonly status: string;
        } | null;
        readonly classificationLevelV2?: {
          readonly color: string | null;
          readonly description: string | null;
          readonly guideline: string | null;
          readonly guidelineADF: string | null;
          readonly id: string;
          readonly name: string;
          readonly status: string;
        };
        readonly featureEnabled: boolean;
        readonly isReclassificationPermitted: boolean;
        readonly source: ClassificationLevelSource | null;
        readonly userOverrideSetting: string | null;
      } | null;
      readonly contentProperties: {
        readonly draft: {
          readonly contentMode: string | null;
        } | null;
        readonly latest: {
          readonly contentMode: string | null;
          readonly generatedBy: string | null;
        } | null;
      } | null;
      readonly contentReactionsSummary?: {
        readonly ari: string;
        readonly containerAri: string;
        readonly reactionsCount: number;
        readonly reactionsSummaryForEmoji: ReadonlyArray<{
          readonly count: number;
          readonly emojiId: string;
          readonly id: string;
          readonly reacted: boolean;
        } | null>;
      } | null;
      readonly contentState: {
        readonly color: string;
        readonly id: string | null;
        readonly name: string;
        readonly restrictionLevel: ContentStateRestrictionLevel;
      } | null;
      readonly contentStateLastUpdated: {
        readonly value: string;
      } | null;
      readonly coverPictureProperties?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly draftVersion: {
        readonly by: {
          readonly __typename: string;
          readonly displayName: string | null;
        } | null;
        readonly contentTypeModified: boolean | null;
        readonly friendlyWhen: string | null;
        readonly number: number | null;
        readonly when: string | null;
      } | null;
      readonly editorProperty?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly emoji?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly emojiTitlePublished?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly hasInheritedRestrictions?: boolean;
      readonly hasRestrictions?: boolean;
      readonly hasViewRestrictions?: boolean;
      readonly history?: {
        readonly createdBy: {
          readonly __typename: "KnownUser";
          readonly accountId: string | null;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
          readonly type: string | null;
        } | {
          readonly __typename: string;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
          readonly type: string | null;
        } | null;
        readonly createdDate: string | null;
        readonly lastOwnedBy: {
          readonly __typename: "KnownUser";
          readonly accountId: string | null;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
          readonly type: string | null;
        } | {
          readonly __typename: string;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
          readonly type: string | null;
        } | null;
        readonly ownedBy: {
          readonly __typename: "KnownUser";
          readonly accountId: string | null;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
          readonly type: string | null;
        } | {
          readonly __typename: string;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
          readonly type: string | null;
        } | null;
      } | null;
      readonly id: string | null;
      readonly labels?: {
        readonly count: number | null;
        readonly nodes: ReadonlyArray<{
          readonly __typename: "Label";
          readonly id: string | null;
          readonly label: string | null;
          readonly name: string | null;
          readonly prefix: string | null;
        } | null> | null;
      } | null;
      readonly links?: {
        readonly base: string | null;
        readonly webui: string | null;
      } | null;
      readonly macroRenderedOutput?: ReadonlyArray<{
        readonly key: string | null;
        readonly value: {
          readonly representation: string | null;
          readonly value: string | null;
          readonly webresource: {
            readonly tags: {
              readonly css: string | null;
              readonly js: string | null;
            } | null;
          } | null;
        } | null;
      } | null> | null;
      readonly metadata: {
        readonly frontend: {
          readonly collabService: string | null;
          readonly contentHash?: string | null;
          readonly coverPictureWidth: string | null;
          readonly embedded: boolean;
          readonly fabricEditorEligibility?: string | null;
          readonly fabricEditorSupported: boolean | null;
        } | null;
        readonly lastModifiedDate: string | null;
        readonly sourceTemplateEntityId: string | null;
      };
      readonly operations: ReadonlyArray<{
        readonly operation: string | null;
        readonly targetType: string | null;
      } | null> | null;
      readonly pageTitleDraft?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly pageTitlePublished?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly smartFolderProperties: {
        readonly nodes: ReadonlyArray<{
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly space: {
        readonly alias: string | null;
        readonly homepageId?: string | null;
        readonly id: string | null;
        readonly key: string | null;
        readonly name: string | null;
      } | null;
      readonly status: string | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly type: string | null;
      readonly version: {
        readonly by: {
          readonly __typename: "KnownUser";
          readonly accountId?: string | null;
          readonly displayName: string | null;
          readonly profilePicture?: {
            readonly path: string;
          } | null;
          readonly type?: string | null;
        } | {
          readonly __typename: string;
          readonly displayName: string | null;
          readonly profilePicture?: {
            readonly path: string;
          } | null;
          readonly type?: string | null;
        } | null;
        readonly confRev: string | null;
        readonly contentTypeModified: boolean | null;
        readonly friendlyWhen: string | null;
        readonly number: number | null;
        readonly when: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly contentAnalyticsViewers?: {
    readonly count: number;
  } | null;
  readonly contentContributors?: {
    readonly count: number | null;
    readonly isCurrentUserContributor: boolean | null;
    readonly isOwnerContributor: boolean | null;
    readonly nodes: ReadonlyArray<{
      readonly __typename: "KnownUser";
      readonly accountId: string | null;
      readonly displayName: string | null;
      readonly profilePicture: {
        readonly path: string;
      } | null;
      readonly type: string | null;
    } | {
      readonly __typename: string;
      readonly displayName: string | null;
      readonly profilePicture: {
        readonly path: string;
      } | null;
      readonly type: string | null;
    } | null> | null;
  } | null;
  readonly dataSecurityPolicy?: {
    readonly isActionEnabledForContent: {
      readonly action: DataSecurityPolicyAction | null;
      readonly allowed: boolean | null;
    };
  } | null;
  readonly knowledgeDiscovery?: {
    readonly keyPhrases: {
      readonly __typename: "KnowledgeDiscoveryKeyPhraseConnection";
      readonly nodes: ReadonlyArray<{
        readonly category: KnowledgeDiscoveryKeyPhraseCategory;
        readonly keyPhrase: string;
      } | null> | null;
    } | {
      readonly __typename: "QueryError";
      readonly message: string | null;
    } | {
      readonly __typename: string;
    } | null;
  } | null;
  readonly mediaConfiguration?: {
    readonly clientId: string;
    readonly fileStoreUrl: string;
  } | null;
  readonly publicLinkPage?: {
    readonly accessType: ConfluenceShareableLinkAccessType | null;
    readonly pageId: string;
    readonly pageStatus: PublicLinkPageStatus;
  } | null;
  readonly space: {
    readonly currentUser: {
      readonly isAnonymouslyAuthorized: boolean;
    };
    readonly id: string | null;
    readonly lookAndFeel: {
      readonly content: {
        readonly container: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly borderRadius: string | null;
          readonly padding: string | null;
        } | null;
        readonly header: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly borderRadius: string | null;
          readonly padding: string | null;
        } | null;
        readonly screen: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly gutterBottom: string | null;
          readonly gutterLeft: string | null;
          readonly gutterRight: string | null;
          readonly gutterTop: string | null;
          readonly layer: {
            readonly background: string | null;
            readonly backgroundAttachment: string | null;
            readonly backgroundBlendMode: string | null;
            readonly backgroundClip: string | null;
            readonly backgroundColor: string | null;
            readonly backgroundImage: string | null;
            readonly backgroundOrigin: string | null;
            readonly backgroundPosition: string | null;
            readonly backgroundRepeat: string | null;
            readonly backgroundSize: string | null;
            readonly height: string | null;
            readonly width: string | null;
          } | null;
        } | null;
      } | null;
      readonly headings: ReadonlyArray<{
        readonly key: string | null;
        readonly value: string | null;
      } | null>;
    } | null;
    readonly settings: {
      readonly customHeaderAndFooter?: {
        readonly footer: {
          readonly css: string;
          readonly html: string;
          readonly js: ReadonlyArray<string | null>;
          readonly spaUnfriendlyMacros: ReadonlyArray<{
            readonly name: string | null;
          }>;
        };
        readonly header: {
          readonly css: string;
          readonly html: string;
          readonly js: ReadonlyArray<string | null>;
          readonly spaUnfriendlyMacros: ReadonlyArray<{
            readonly name: string | null;
          }>;
        };
      };
      readonly routeOverrideEnabled: boolean | null;
    } | null;
    readonly theme: {
      readonly name: string | null;
      readonly themeKey: string | null;
    } | null;
  } | null;
  readonly user?: {
    readonly confluence: {
      readonly permissionType: SitePermissionType | null;
    } | null;
    readonly id: string | null;
  } | null;
};
export type ContentBlogUnifiedQuery = {
  rawResponse: ContentBlogUnifiedQuery$rawResponse;
  response: ContentBlogUnifiedQuery$data;
  variables: ContentBlogUnifiedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "autohighlightsEntityAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "autohighlightsWorkspaceId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bylineContributorsLimit"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAgentTrustReceiptData"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAnalyticsByline"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAudioContent"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAutohighlights"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAutomationDiscoveries"
},
v9 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeBylineContributors"
},
v10 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeClassification"
},
v11 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeContentHeader"
},
v12 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeContentHeaderAccess"
},
v13 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeContentHeaderPublicLink"
},
v14 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeFabricEditorEligibility"
},
v15 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeReactions"
},
v16 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRendererAssetsCustomChrome"
},
v17 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRendererAssetsDsp"
},
v18 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRendererAssetsMedia"
},
v19 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRestrictionAncestors"
},
v20 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRestrictions"
},
v21 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isSSR"
},
v22 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "preloadLabels"
},
v23 = {
  "defaultValue": "PAGE_EXPORT",
  "kind": "LocalArgument",
  "name": "rendererAssetsDspAction"
},
v24 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v25 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "useClassificationLevelV2"
},
v26 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "useContentModeFragment"
},
v27 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "useNewContentTopper"
},
v28 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionOverride"
},
v29 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "contentId"
},
v30 = [
  (v29/*: any*/),
  {
    "kind": "Variable",
    "name": "version",
    "variableName": "versionOverride"
  }
],
v31 = {
  "kind": "ScalarField",
  "name": "id"
},
v32 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v33 = {
  "kind": "ScalarField",
  "name": "type"
},
v34 = {
  "kind": "ScalarField",
  "name": "status"
},
v35 = [
  {
    "kind": "ScalarField",
    "name": "contentMode"
  }
],
v36 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": (v35/*: any*/)
    },
    {
      "concreteType": "DraftContentProperties",
      "kind": "LinkedField",
      "name": "draft",
      "plural": false,
      "selections": (v35/*: any*/)
    }
  ]
},
v37 = {
  "kind": "ScalarField",
  "name": "name"
},
v38 = {
  "kind": "ScalarField",
  "name": "color"
},
v39 = {
  "args": [
    {
      "kind": "Literal",
      "name": "isDraft",
      "value": false
    }
  ],
  "concreteType": "ContentState",
  "kind": "LinkedField",
  "name": "contentState",
  "plural": false,
  "selections": [
    (v31/*: any*/),
    (v37/*: any*/),
    (v38/*: any*/),
    {
      "kind": "ScalarField",
      "name": "restrictionLevel"
    }
  ],
  "storageKey": "contentState(isDraft:false)"
},
v40 = {
  "kind": "ScalarField",
  "name": "value"
},
v41 = {
  "args": [
    {
      "kind": "Literal",
      "name": "format",
      "value": "USER_FRIENDLY"
    }
  ],
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "contentStateLastUpdated",
  "plural": false,
  "selections": [
    (v40/*: any*/)
  ],
  "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
},
v42 = {
  "kind": "ScalarField",
  "name": "title"
},
v43 = {
  "kind": "ScalarField",
  "name": "key"
},
v44 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v31/*: any*/),
    (v37/*: any*/),
    (v43/*: any*/),
    {
      "kind": "ScalarField",
      "name": "alias"
    }
  ]
},
v45 = {
  "kind": "ScalarField",
  "name": "subType"
},
v46 = [
  (v43/*: any*/),
  (v40/*: any*/)
],
v47 = {
  "alias": "smartFolderProperties",
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "smartFolderProperties"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": (v46/*: any*/)
    }
  ],
  "storageKey": "properties(keys:[\"smartFolderProperties\"])"
},
v48 = {
  "kind": "ScalarField",
  "name": "contentTypeModified"
},
v49 = {
  "kind": "ScalarField",
  "name": "number"
},
v50 = {
  "kind": "ScalarField",
  "name": "friendlyWhen"
},
v51 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v52 = [
  (v51/*: any*/)
],
v53 = {
  "kind": "LinkedField",
  "name": "by",
  "plural": false,
  "selections": (v52/*: any*/)
},
v54 = {
  "kind": "ScalarField",
  "name": "when"
},
v55 = {
  "kind": "ScalarField",
  "name": "confRev"
},
v56 = [
  {
    "kind": "ScalarField",
    "name": "coverPictureWidth"
  }
],
v57 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
      "kind": "LinkedField",
      "name": "frontend",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "fabricEditorSupported"
        },
        {
          "kind": "ScalarField",
          "name": "embedded"
        },
        {
          "kind": "ScalarField",
          "name": "collabService"
        },
        {
          "condition": "useNewContentTopper",
          "kind": "Condition",
          "passingValue": true,
          "selections": (v56/*: any*/)
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    }
  ]
},
v58 = {
  "kind": "ScalarField",
  "name": "representation"
},
v59 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    (v49/*: any*/)
  ]
},
v60 = {
  "kind": "ScalarField",
  "name": "js"
},
v61 = {
  "kind": "ScalarField",
  "name": "css"
},
v62 = {
  "concreteType": "WebResourceTags",
  "kind": "LinkedField",
  "name": "tags",
  "plural": false,
  "selections": [
    (v60/*: any*/),
    (v61/*: any*/)
  ]
},
v63 = [
  (v62/*: any*/)
],
v64 = {
  "concreteType": "ContentBodyPerRepresentation",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentBody",
      "kind": "LinkedField",
      "name": "dynamic",
      "plural": false,
      "selections": [
        (v58/*: any*/),
        (v40/*: any*/),
        {
          "concreteType": "Content",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            (v31/*: any*/),
            (v59/*: any*/)
          ]
        },
        {
          "concreteType": "WebResourceDependencies",
          "kind": "LinkedField",
          "name": "webresource",
          "plural": false,
          "selections": [
            {
              "concreteType": "SuperBatchWebResources",
              "kind": "LinkedField",
              "name": "superbatch",
              "plural": false,
              "selections": (v63/*: any*/)
            },
            (v62/*: any*/)
          ]
        }
      ]
    }
  ]
},
v65 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v31/*: any*/),
      (v43/*: any*/),
      (v40/*: any*/),
      (v59/*: any*/)
    ]
  }
],
v66 = {
  "alias": "appearancePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "content-appearance-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v65/*: any*/),
  "storageKey": "properties(key:\"content-appearance-published\")"
},
v67 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "cover-picture-id-published",
        "emoji-title-published",
        "editor",
        "import-source",
        "imported-page-modified-date"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v65/*: any*/),
  "storageKey": "properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"])"
},
v68 = {
  "alias": "pageTitlePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "page-title-property-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v65/*: any*/),
  "storageKey": "properties(key:\"page-title-property-published\")"
},
v69 = {
  "alias": "pageTitleDraft",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "page-title-property-draft"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v65/*: any*/),
  "storageKey": "properties(key:\"page-title-property-draft\")"
},
v70 = {
  "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
  "kind": "LinkedField",
  "name": "frontend",
  "plural": false,
  "selections": (v56/*: any*/)
},
v71 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    (v70/*: any*/)
  ]
},
v72 = {
  "alias": "coverPictureProperties",
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "cover-picture-id-draft",
        "cover-picture-id-published"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v65/*: any*/),
  "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
},
v73 = {
  "kind": "ScalarField",
  "name": "hasInheritedRestrictions"
},
v74 = {
  "kind": "ScalarField",
  "name": "hasRestrictions"
},
v75 = {
  "kind": "ScalarField",
  "name": "hasViewRestrictions"
},
v76 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "ASCENDING",
      "sortField": "LABELLING_CREATIONDATE"
    }
  }
],
v77 = {
  "kind": "ScalarField",
  "name": "count"
},
v78 = {
  "kind": "ScalarField",
  "name": "label"
},
v79 = {
  "kind": "ScalarField",
  "name": "prefix"
},
v80 = {
  "concreteType": "ReactionsSummaryResponse",
  "kind": "LinkedField",
  "name": "contentReactionsSummary",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "reactionsCount"
    },
    {
      "kind": "ScalarField",
      "name": "ari"
    },
    {
      "kind": "ScalarField",
      "name": "containerAri"
    },
    {
      "concreteType": "ReactionsSummaryForEmoji",
      "kind": "LinkedField",
      "name": "reactionsSummaryForEmoji",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "emojiId"
        },
        (v77/*: any*/),
        {
          "kind": "ScalarField",
          "name": "reacted"
        },
        (v31/*: any*/)
      ]
    }
  ]
},
v81 = [
  {
    "kind": "Literal",
    "name": "key",
    "value": "emoji-title-published"
  }
],
v82 = {
  "alias": "emoji",
  "args": (v81/*: any*/),
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v31/*: any*/),
        (v40/*: any*/)
      ]
    }
  ],
  "storageKey": "properties(key:\"emoji-title-published\")"
},
v83 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v84 = [
  (v51/*: any*/),
  (v83/*: any*/)
],
v85 = {
  "kind": "ScalarField",
  "name": "webui"
},
v86 = {
  "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    (v85/*: any*/),
    {
      "kind": "ScalarField",
      "name": "base"
    }
  ]
},
v87 = {
  "alias": "audioProperties",
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "emoji-title-published",
        "editor"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v40/*: any*/),
        (v43/*: any*/)
      ]
    }
  ],
  "storageKey": "properties(keys:[\"emoji-title-published\",\"editor\"])"
},
v88 = {
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "ancestors",
  "plural": true,
  "selections": [
    (v31/*: any*/),
    (v42/*: any*/),
    (v74/*: any*/),
    {
      "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": [
        (v85/*: any*/)
      ]
    }
  ]
},
v89 = [
  {
    "kind": "Variable",
    "name": "useClassificationLevelV2",
    "variableName": "useClassificationLevelV2"
  }
],
v90 = {
  "kind": "ScalarField",
  "name": "createdDate"
},
v91 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "generatedBy"
        }
      ]
    }
  ]
},
v92 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "spaceKey"
  }
],
v93 = {
  "kind": "ScalarField",
  "name": "themeKey"
},
v94 = {
  "kind": "ScalarField",
  "name": "background"
},
v95 = {
  "kind": "ScalarField",
  "name": "backgroundColor"
},
v96 = {
  "kind": "ScalarField",
  "name": "backgroundImage"
},
v97 = {
  "kind": "ScalarField",
  "name": "backgroundPosition"
},
v98 = {
  "kind": "ScalarField",
  "name": "backgroundSize"
},
v99 = {
  "kind": "ScalarField",
  "name": "backgroundRepeat"
},
v100 = {
  "kind": "ScalarField",
  "name": "backgroundOrigin"
},
v101 = {
  "kind": "ScalarField",
  "name": "backgroundClip"
},
v102 = {
  "kind": "ScalarField",
  "name": "backgroundAttachment"
},
v103 = {
  "kind": "ScalarField",
  "name": "backgroundBlendMode"
},
v104 = {
  "concreteType": "ScreenLookAndFeel",
  "kind": "LinkedField",
  "name": "screen",
  "plural": false,
  "selections": [
    (v94/*: any*/),
    (v95/*: any*/),
    (v96/*: any*/),
    (v97/*: any*/),
    (v98/*: any*/),
    (v99/*: any*/),
    (v100/*: any*/),
    (v101/*: any*/),
    (v102/*: any*/),
    (v103/*: any*/),
    {
      "concreteType": "LayerScreenLookAndFeel",
      "kind": "LinkedField",
      "name": "layer",
      "plural": false,
      "selections": [
        (v94/*: any*/),
        (v95/*: any*/),
        (v96/*: any*/),
        (v97/*: any*/),
        (v98/*: any*/),
        (v99/*: any*/),
        (v100/*: any*/),
        (v101/*: any*/),
        (v102/*: any*/),
        (v103/*: any*/),
        {
          "kind": "ScalarField",
          "name": "width"
        },
        {
          "kind": "ScalarField",
          "name": "height"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "gutterTop"
    },
    {
      "kind": "ScalarField",
      "name": "gutterRight"
    },
    {
      "kind": "ScalarField",
      "name": "gutterBottom"
    },
    {
      "kind": "ScalarField",
      "name": "gutterLeft"
    }
  ]
},
v105 = {
  "kind": "ScalarField",
  "name": "padding"
},
v106 = {
  "kind": "ScalarField",
  "name": "borderRadius"
},
v107 = {
  "concreteType": "ContainerLookAndFeel",
  "kind": "LinkedField",
  "name": "container",
  "plural": false,
  "selections": [
    (v94/*: any*/),
    (v95/*: any*/),
    (v96/*: any*/),
    (v97/*: any*/),
    (v98/*: any*/),
    (v99/*: any*/),
    (v100/*: any*/),
    (v101/*: any*/),
    (v102/*: any*/),
    (v103/*: any*/),
    (v105/*: any*/),
    (v106/*: any*/)
  ]
},
v108 = {
  "concreteType": "SpaceSettings",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "routeOverrideEnabled"
    }
  ]
},
v109 = {
  "concreteType": "SpaceUserMetadata",
  "kind": "LinkedField",
  "name": "currentUser",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isAnonymouslyAuthorized"
    }
  ]
},
v110 = [
  {
    "kind": "ScalarField",
    "name": "html"
  },
  (v60/*: any*/),
  (v61/*: any*/),
  {
    "concreteType": "SpaUnfriendlyMacro",
    "kind": "LinkedField",
    "name": "spaUnfriendlyMacros",
    "plural": true,
    "selections": [
      (v37/*: any*/)
    ]
  }
],
v111 = {
  "condition": "includeRendererAssetsCustomChrome",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "SpaceSettings",
      "kind": "LinkedField",
      "name": "settings",
      "plural": false,
      "selections": [
        {
          "concreteType": "SpaceSettingsMetadata",
          "kind": "LinkedField",
          "name": "customHeaderAndFooter",
          "plural": false,
          "selections": [
            {
              "concreteType": "HtmlMeta",
              "kind": "LinkedField",
              "name": "header",
              "plural": false,
              "selections": (v110/*: any*/)
            },
            {
              "concreteType": "HtmlMeta",
              "kind": "LinkedField",
              "name": "footer",
              "plural": false,
              "selections": (v110/*: any*/)
            }
          ]
        }
      ]
    }
  ]
},
v112 = {
  "condition": "includeRendererAssetsMedia",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "MediaConfiguration",
      "kind": "LinkedField",
      "name": "mediaConfiguration",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "clientId"
        },
        {
          "kind": "ScalarField",
          "name": "fileStoreUrl"
        }
      ]
    }
  ]
},
v113 = {
  "kind": "Variable",
  "name": "contentId",
  "variableName": "contentId"
},
v114 = {
  "condition": "includeRendererAssetsDsp",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "Confluence_dataSecurityPolicy",
      "kind": "LinkedField",
      "name": "dataSecurityPolicy",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "action",
              "variableName": "rendererAssetsDspAction"
            },
            (v113/*: any*/),
            {
              "kind": "Literal",
              "name": "contentStatus",
              "value": "CURRENT"
            },
            {
              "kind": "Literal",
              "name": "contentVersion",
              "value": 1
            },
            {
              "kind": "Variable",
              "name": "spaceKey",
              "variableName": "spaceKey"
            }
          ],
          "concreteType": "DataSecurityPolicyDecision",
          "kind": "LinkedField",
          "name": "isActionEnabledForContent",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "action"
            },
            {
              "kind": "ScalarField",
              "name": "allowed"
            }
          ]
        }
      ]
    }
  ]
},
v115 = [
  {
    "kind": "Variable",
    "name": "entityAri",
    "variableName": "autohighlightsEntityAri"
  },
  {
    "kind": "Variable",
    "name": "workspaceId",
    "variableName": "autohighlightsWorkspaceId"
  }
],
v116 = [
  (v113/*: any*/)
],
v117 = {
  "condition": "includeContentHeaderPublicLink",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "pageId",
          "variableName": "contentId"
        }
      ],
      "concreteType": "PublicLinkPage",
      "kind": "LinkedField",
      "name": "publicLinkPage",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "pageId"
        },
        {
          "kind": "ScalarField",
          "name": "pageStatus"
        },
        {
          "kind": "ScalarField",
          "name": "accessType"
        }
      ]
    }
  ]
},
v118 = [
  (v29/*: any*/),
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "bylineContributorsLimit"
  }
],
v119 = {
  "kind": "ScalarField",
  "name": "isCurrentUserContributor"
},
v120 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v121 = [
  (v120/*: any*/),
  (v51/*: any*/)
],
v122 = {
  "kind": "LinkedField",
  "name": "by",
  "plural": false,
  "selections": (v121/*: any*/)
},
v123 = {
  "kind": "ScalarField",
  "name": "sourceTemplateEntityId"
},
v124 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v125 = [
  (v120/*: any*/),
  (v33/*: any*/),
  (v51/*: any*/),
  (v124/*: any*/),
  (v83/*: any*/)
],
v126 = [
  (v73/*: any*/),
  (v74/*: any*/),
  (v75/*: any*/)
],
v127 = [
  (v120/*: any*/),
  (v51/*: any*/),
  (v83/*: any*/)
],
v128 = [
  (v31/*: any*/),
  {
    "kind": "ScalarField",
    "name": "guideline"
  },
  {
    "kind": "ScalarField",
    "name": "guidelineADF"
  },
  {
    "kind": "ScalarField",
    "name": "description"
  },
  (v38/*: any*/),
  (v37/*: any*/),
  (v34/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ContentBlogUnifiedQuery",
    "selections": [
      {
        "args": (v30/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v36/*: any*/),
              (v39/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v44/*: any*/),
              (v45/*: any*/),
              (v47/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v48/*: any*/),
                  (v49/*: any*/),
                  (v50/*: any*/),
                  (v53/*: any*/),
                  (v54/*: any*/),
                  (v55/*: any*/)
                ]
              },
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "draftVersion",
                "plural": false,
                "selections": [
                  (v48/*: any*/),
                  (v49/*: any*/),
                  (v50/*: any*/),
                  (v53/*: any*/),
                  (v54/*: any*/)
                ]
              },
              (v57/*: any*/),
              (v64/*: any*/),
              (v66/*: any*/),
              (v67/*: any*/),
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "ViewPageCommentsPanelPermission_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "commentsPanelPermission"
              },
              {
                "kind": "FragmentSpread",
                "name": "PageStatusQueryRelaySpike_content"
              },
              {
                "kind": "FragmentSpread",
                "name": "PresenterModePortal_content"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "ArchivedPageBannerV2Status_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "archivedPageBannerStatusFragment"
              },
              {
                "condition": "useContentModeFragment",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "ContentModeFragmentProvider_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "viewPageContentMode"
                  }
                ]
              },
              {
                "condition": "includeBylineContributors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "args": [
                            {
                              "kind": "Variable",
                              "name": "useNewContentTopper",
                              "variableName": "useNewContentTopper"
                            }
                          ],
                          "kind": "FragmentSpread",
                          "name": "ContentTitleWithByLine_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "contentTitleWithByLine"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "useTitleContentPropertiesForPublishedPage_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "rendererTitleContentProperties"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "CoverPictureQuery_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "rendererCoverPicture"
                  }
                ]
              },
              {
                "condition": "includeAutomationDiscoveries",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "MeetingNotesAutomationDiscoveryFragment_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "meetingNotesAutomationDiscoveryFragment"
                  }
                ]
              },
              {
                "condition": "includeContentHeader",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "args": [
                            {
                              "kind": "Variable",
                              "name": "includeAccessButton",
                              "variableName": "includeContentHeaderAccess"
                            },
                            {
                              "kind": "Variable",
                              "name": "includeFabricEditorEligibility",
                              "variableName": "includeFabricEditorEligibility"
                            }
                          ],
                          "kind": "FragmentSpread",
                          "name": "ContentHeader_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "contentHeaderFragment"
                  }
                ]
              },
              {
                "condition": "useNewContentTopper",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v31/*: any*/),
                        (v68/*: any*/),
                        (v69/*: any*/),
                        (v71/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "titleContentProperties"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v31/*: any*/),
                        (v72/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "coverPicture"
                  },
                  (v68/*: any*/)
                ]
              },
              {
                "condition": "includeRestrictions",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v31/*: any*/),
                        (v73/*: any*/),
                        (v74/*: any*/),
                        (v75/*: any*/),
                        (v42/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "shareAndRestrictButtonData"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v31/*: any*/),
                        (v73/*: any*/),
                        (v75/*: any*/),
                        (v74/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "pageRestrictionsContext"
                  }
                ]
              },
              {
                "condition": "preloadLabels",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "ViewPageLabelsContentFragment_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "viewPageLabels"
                  },
                  {
                    "args": (v76/*: any*/),
                    "concreteType": "PaginatedLabelList",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      (v77/*: any*/),
                      {
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v31/*: any*/),
                          (v78/*: any*/),
                          (v37/*: any*/),
                          (v79/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                  }
                ]
              },
              {
                "condition": "includeReactions",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v31/*: any*/),
                        (v80/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "reactionsContent"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "ReactionsContentFragment_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "reactionsContentFragment"
                  }
                ]
              },
              {
                "condition": "includeAudioContent",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v31/*: any*/),
                        (v42/*: any*/),
                        (v45/*: any*/),
                        (v82/*: any*/),
                        {
                          "concreteType": "History",
                          "kind": "LinkedField",
                          "name": "history",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "name": "createdBy",
                              "plural": false,
                              "selections": (v84/*: any*/)
                            },
                            {
                              "kind": "LinkedField",
                              "name": "ownedBy",
                              "plural": false,
                              "selections": (v84/*: any*/)
                            }
                          ]
                        },
                        (v86/*: any*/),
                        (v87/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "audioContent"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "AudioContentFragment_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "audioContentFragment"
                  }
                ]
              },
              {
                "condition": "includeRestrictionAncestors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v31/*: any*/),
                        (v88/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "pageRestrictionsContextAncestors"
                  }
                ]
              },
              {
                "condition": "includeClassification",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "args": (v89/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "BylineClassification_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "bylineClassificationFragment"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "args": (v89/*: any*/),
                          "kind": "FragmentSpread",
                          "name": "useContentClassification_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "contentClassificationFragment"
                  }
                ]
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "PageContentRenderer_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "pageContentRendererFragment"
              },
              {
                "condition": "includeAgentTrustReceiptData",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v90/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v52/*: any*/)
                      }
                    ]
                  },
                  (v91/*: any*/)
                ]
              },
              {
                "condition": "includeRendererAssetsMedia",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "ViewPageExtensionsAndRendererAssetsContentFragment_mediaContent"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "rendererAssetsMedia"
                  }
                ]
              },
              {
                "condition": "isSSR",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "ViewPageExtensionsAndRendererAssetsContentFragment_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "rendererAssetsMacroOutput"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "args": (v92/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v31/*: any*/),
          {
            "concreteType": "Theme",
            "kind": "LinkedField",
            "name": "theme",
            "plural": false,
            "selections": [
              (v93/*: any*/),
              (v37/*: any*/)
            ]
          },
          {
            "concreteType": "LookAndFeel",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentLookAndFeel",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v104/*: any*/),
                  (v107/*: any*/)
                ]
              }
            ]
          },
          (v108/*: any*/),
          (v109/*: any*/),
          (v111/*: any*/),
          {
            "condition": "includeContentHeader",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "ContentHeader_space"
                    }
                  ],
                  "type": "Space"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "contentHeaderFragment"
              }
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "ContentContainerTheme_space"
          },
          {
            "kind": "FragmentSpread",
            "name": "ContentTitle_space"
          },
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "PageContentRenderer_space"
                }
              ],
              "type": "Space"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "pageContentRendererFragment"
          }
        ]
      },
      (v112/*: any*/),
      (v114/*: any*/),
      {
        "condition": "includeAutohighlights",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": (v115/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "preloadAutohighlightsQuery_query"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "autohighlightsQueryFragment"
          }
        ]
      },
      {
        "condition": "includeAnalyticsByline",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": (v116/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "AnalyticsByLine_query"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "analyticsBylineFragment"
          }
        ]
      },
      (v117/*: any*/),
      {
        "condition": "includeBylineContributors",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v118/*: any*/),
            "concreteType": "ContentContributors",
            "kind": "LinkedField",
            "name": "contentContributors",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "ByLineContributors_contentContributors"
              },
              {
                "kind": "FragmentSpread",
                "name": "NudgeContributorFilter_contentContributors"
              },
              {
                "kind": "FragmentSpread",
                "name": "SmartsFeedbackComponent_contentContributors"
              },
              {
                "kind": "FragmentSpread",
                "name": "PageHeaderLoomButton_contentContributors"
              },
              (v119/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v24/*: any*/),
      (v28/*: any*/),
      (v21/*: any*/),
      (v18/*: any*/),
      (v17/*: any*/),
      (v16/*: any*/),
      (v23/*: any*/),
      (v27/*: any*/),
      (v22/*: any*/),
      (v4/*: any*/),
      (v9/*: any*/),
      (v2/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/),
      (v15/*: any*/),
      (v20/*: any*/),
      (v19/*: any*/),
      (v10/*: any*/),
      (v25/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v14/*: any*/),
      (v13/*: any*/),
      (v5/*: any*/),
      (v26/*: any*/),
      (v7/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContentBlogUnifiedQuery",
    "selections": [
      {
        "args": (v30/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v42/*: any*/),
              (v67/*: any*/),
              (v36/*: any*/),
              (v39/*: any*/),
              (v41/*: any*/),
              (v44/*: any*/),
              (v45/*: any*/),
              (v47/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v48/*: any*/),
                  (v49/*: any*/),
                  (v50/*: any*/),
                  (v122/*: any*/),
                  (v54/*: any*/),
                  (v55/*: any*/)
                ]
              },
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "draftVersion",
                "plural": false,
                "selections": [
                  (v48/*: any*/),
                  (v49/*: any*/),
                  (v50/*: any*/),
                  (v122/*: any*/),
                  (v54/*: any*/)
                ]
              },
              (v57/*: any*/),
              (v64/*: any*/),
              (v66/*: any*/),
              {
                "condition": "includeBylineContributors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "emojiTitlePublished",
                    "args": (v81/*: any*/),
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": (v65/*: any*/),
                    "storageKey": "properties(key:\"emoji-title-published\")"
                  },
                  {
                    "alias": "editorProperty",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "key",
                        "value": "editor"
                      }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v31/*: any*/),
                          (v43/*: any*/),
                          (v40/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "properties(key:\"editor\")"
                  },
                  {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                      (v70/*: any*/),
                      (v123/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "homepageId"
                      }
                    ]
                  },
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v90/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v125/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": (v125/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "lastOwnedBy",
                        "plural": false,
                        "selections": (v125/*: any*/)
                      }
                    ]
                  },
                  {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                          (v33/*: any*/),
                          (v83/*: any*/),
                          (v124/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v91/*: any*/),
                  (v68/*: any*/),
                  (v69/*: any*/),
                  (v72/*: any*/)
                ]
              },
              {
                "condition": "includeAutomationDiscoveries",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                      (v123/*: any*/)
                    ]
                  }
                ]
              },
              {
                "condition": "includeContentHeader",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "condition": "includeFabricEditorEligibility",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "ContentMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                            "kind": "LinkedField",
                            "name": "frontend",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "fabricEditorEligibility"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "contentHash"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "includeContentHeaderAccess",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": (v126/*: any*/)
                  }
                ]
              },
              {
                "condition": "useNewContentTopper",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v68/*: any*/),
                  (v69/*: any*/),
                  (v71/*: any*/),
                  (v72/*: any*/)
                ]
              },
              {
                "condition": "includeRestrictions",
                "kind": "Condition",
                "passingValue": true,
                "selections": (v126/*: any*/)
              },
              {
                "condition": "preloadLabels",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v76/*: any*/),
                    "concreteType": "PaginatedLabelList",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      (v77/*: any*/),
                      {
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v120/*: any*/),
                          (v31/*: any*/),
                          (v78/*: any*/),
                          (v37/*: any*/),
                          (v79/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                  }
                ]
              },
              {
                "condition": "includeReactions",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v80/*: any*/)
                ]
              },
              {
                "condition": "includeAudioContent",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v82/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v127/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": (v127/*: any*/)
                      }
                    ]
                  },
                  (v86/*: any*/),
                  (v87/*: any*/)
                ]
              },
              {
                "condition": "includeRestrictionAncestors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v88/*: any*/)
                ]
              },
              {
                "condition": "includeClassification",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "ClassificationLevelDetails",
                    "kind": "LinkedField",
                    "name": "classificationLevelDetails",
                    "plural": false,
                    "selections": [
                      {
                        "condition": "useClassificationLevelV2",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                          {
                            "concreteType": "ContentDataClassificationLevel",
                            "kind": "LinkedField",
                            "name": "classificationLevel",
                            "plural": false,
                            "selections": (v128/*: any*/)
                          }
                        ]
                      },
                      {
                        "condition": "useClassificationLevelV2",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "ContentDataClassificationLevel",
                            "kind": "LinkedField",
                            "name": "classificationLevelV2",
                            "plural": false,
                            "selections": (v128/*: any*/)
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "featureEnabled"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "source"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isReclassificationPermitted"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "canManageSpaceSettings"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "classificationControlSetting"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "userOverrideSetting"
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "includeAgentTrustReceiptData",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v90/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v121/*: any*/)
                      }
                    ]
                  },
                  (v91/*: any*/)
                ]
              },
              {
                "condition": "includeRendererAssetsMedia",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ContentBody",
                        "kind": "LinkedField",
                        "name": "atlas_doc_format",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "EmbeddedMediaToken",
                            "kind": "LinkedField",
                            "name": "mediaToken",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "token"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "isSSR",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "MapOfStringToFormattedBody",
                    "kind": "LinkedField",
                    "name": "macroRenderedOutput",
                    "plural": true,
                    "selections": [
                      (v43/*: any*/),
                      {
                        "concreteType": "FormattedBody",
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": false,
                        "selections": [
                          (v40/*: any*/),
                          (v58/*: any*/),
                          {
                            "concreteType": "WebResourceDependencies",
                            "kind": "LinkedField",
                            "name": "webresource",
                            "plural": false,
                            "selections": (v63/*: any*/)
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "args": (v92/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          {
            "concreteType": "Theme",
            "kind": "LinkedField",
            "name": "theme",
            "plural": false,
            "selections": [
              (v37/*: any*/),
              (v93/*: any*/)
            ]
          },
          {
            "concreteType": "LookAndFeel",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentLookAndFeel",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v104/*: any*/),
                  (v107/*: any*/),
                  {
                    "concreteType": "ContainerLookAndFeel",
                    "kind": "LinkedField",
                    "name": "header",
                    "plural": false,
                    "selections": [
                      (v94/*: any*/),
                      (v102/*: any*/),
                      (v103/*: any*/),
                      (v101/*: any*/),
                      (v95/*: any*/),
                      (v96/*: any*/),
                      (v100/*: any*/),
                      (v97/*: any*/),
                      (v99/*: any*/),
                      (v98/*: any*/),
                      (v106/*: any*/),
                      (v105/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "MapOfStringToString",
                "kind": "LinkedField",
                "name": "headings",
                "plural": true,
                "selections": (v46/*: any*/)
              }
            ]
          },
          (v31/*: any*/),
          (v108/*: any*/),
          (v109/*: any*/),
          (v111/*: any*/)
        ]
      },
      (v112/*: any*/),
      (v114/*: any*/),
      {
        "condition": "includeAutohighlights",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "KnowledgeDiscoveryQueryApi",
            "kind": "LinkedField",
            "name": "knowledgeDiscovery",
            "plural": false,
            "selections": [
              {
                "args": (v115/*: any*/),
                "kind": "LinkedField",
                "name": "keyPhrases",
                "plural": false,
                "selections": [
                  (v120/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "KnowledgeDiscoveryKeyPhrase",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "keyPhrase"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "category"
                          }
                        ]
                      }
                    ],
                    "type": "KnowledgeDiscoveryKeyPhraseConnection"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "message"
                      }
                    ],
                    "type": "QueryError"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "includeAnalyticsByline",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v116/*: any*/),
            "concreteType": "ContentAnalyticsViewers",
            "kind": "LinkedField",
            "name": "contentAnalyticsViewers",
            "plural": false,
            "selections": [
              (v77/*: any*/)
            ]
          },
          {
            "alias": "user",
            "args": [
              {
                "kind": "Literal",
                "name": "current",
                "value": true
              }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
              (v31/*: any*/),
              {
                "concreteType": "ConfluenceUser",
                "kind": "LinkedField",
                "name": "confluence",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "permissionType"
                  }
                ]
              }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
          }
        ]
      },
      (v117/*: any*/),
      {
        "condition": "includeBylineContributors",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v118/*: any*/),
            "concreteType": "ContentContributors",
            "kind": "LinkedField",
            "name": "contentContributors",
            "plural": false,
            "selections": [
              (v77/*: any*/),
              (v119/*: any*/),
              {
                "kind": "ScalarField",
                "name": "isOwnerContributor"
              },
              {
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v125/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "63fd75032fa3f9112c9f1e1c21394717",
    "id": "f425c5e84e5ae3be9c4a6c8cbdcbea20d9d2824721d880485bb79752791e8f80",
    "metadata": {},
    "name": "ContentBlogUnifiedQuery",
    "operationKind": "query",
    "text": "query ContentBlogUnifiedQuery($contentId:ID!,$spaceKey:String=null,$versionOverride:Int,$isSSR:Boolean=false,$includeRendererAssetsMedia:Boolean=false,$includeRendererAssetsDsp:Boolean=false,$includeRendererAssetsCustomChrome:Boolean=false,$rendererAssetsDspAction:DataSecurityPolicyAction=PAGE_EXPORT,$useNewContentTopper:Boolean=false,$preloadLabels:Boolean=false,$includeAgentTrustReceiptData:Boolean=false,$includeBylineContributors:Boolean=false,$bylineContributorsLimit:Int,$includeAutomationDiscoveries:Boolean=false,$includeAudioContent:Boolean=false,$includeReactions:Boolean=false,$includeRestrictions:Boolean=false,$includeRestrictionAncestors:Boolean=false,$includeClassification:Boolean=false,$useClassificationLevelV2:Boolean=false,$includeContentHeader:Boolean=false,$includeContentHeaderAccess:Boolean=false,$includeFabricEditorEligibility:Boolean=false,$includeContentHeaderPublicLink:Boolean=false,$includeAnalyticsByline:Boolean=false,$useContentModeFragment:Boolean=false,$includeAutohighlights:Boolean=false,$autohighlightsEntityAri:String,$autohighlightsWorkspaceId:String){mediaConfiguration@include(if:$includeRendererAssetsMedia){clientId,fileStoreUrl},dataSecurityPolicy@include(if:$includeRendererAssetsDsp){isActionEnabledForContent(action:$rendererAssetsDspAction,contentId:$contentId,contentStatus:CURRENT,contentVersion:1,spaceKey:$spaceKey){action,allowed}},...preloadAutohighlightsQuery_query_deyB3@include(if:$includeAutohighlights),...AnalyticsByLine_query_3SK5LQ@include(if:$includeAnalyticsByline),publicLinkPage(pageId:$contentId)@include(if:$includeContentHeaderPublicLink){pageId,pageStatus,accessType},content(id:$contentId,version:$versionOverride){nodes{...ViewPageCommentsPanelPermission_content,id,operations{operation,targetType},type,...PageStatusQueryRelaySpike_content,...PresenterModePortal_content,status,...ArchivedPageBannerV2Status_content,contentProperties{latest{contentMode},draft{contentMode}},...ContentModeFragmentProvider_content@include(if:$useContentModeFragment),contentState(isDraft:false){id,name,color,restrictionLevel},contentStateLastUpdated(format:USER_FRIENDLY){value},...ContentTitleWithByLine_content_2SjeOj@include(if:$includeBylineContributors)\n      ...useTitleContentPropertiesForPublishedPage_content@include(if:$includeBylineContributors)\n      ...CoverPictureQuery_content@include(if:$includeBylineContributors),...MeetingNotesAutomationDiscoveryFragment_content@include(if:$includeAutomationDiscoveries),title,space{id,name,key,alias},subType,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when,confRev,when@include(if:$includeAgentTrustReceiptData)},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},...ContentHeader_content_118EQH@include(if:$includeContentHeader),metadata{frontend{fabricEditorSupported,embedded,collabService,coverPictureWidth@include(if:$useNewContentTopper)},lastModifiedDate},id@include(if:$useNewContentTopper)\n      pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}}\n      pageTitleDraft:properties(key:\"page-title-property-draft\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}}\n      metadata@include(if:$useNewContentTopper){frontend{coverPictureWidth}}\n      coverPictureProperties:properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},id@include(if:$includeRestrictions)\n      hasInheritedRestrictions@include(if:$includeRestrictions)\n      hasRestrictions@include(if:$includeRestrictions)\n      hasViewRestrictions@include(if:$includeRestrictions)\n      title@include(if:$includeRestrictions),...ViewPageLabelsContentFragment_content@include(if:$preloadLabels)\n      labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING})@include(if:$preloadLabels){count,nodes{id,label,name,prefix}},id@include(if:$includeReactions)\n      contentReactionsSummary@include(if:$includeReactions){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}\n      ...ReactionsContentFragment_content@include(if:$includeReactions),id@include(if:$includeAudioContent)\n      title@include(if:$includeAudioContent)\n      subType@include(if:$includeAudioContent)\n      emoji:properties(key:\"emoji-title-published\")@include(if:$includeAudioContent){nodes{id,value}}\n      history@include(if:$includeAudioContent){createdBy{__typename,displayName,profilePicture{path}},ownedBy{__typename,displayName,profilePicture{path}}}\n      links@include(if:$includeAudioContent){webui,base}\n      audioProperties:properties(keys:[\"emoji-title-published\",\"editor\"])@include(if:$includeAudioContent){nodes{value,key}}\n      ...AudioContentFragment_content@include(if:$includeAudioContent),id@include(if:$includeRestrictionAncestors)\n      ancestors@include(if:$includeRestrictionAncestors){id,title,hasRestrictions,links{webui}},...BylineClassification_content_4MZOe@include(if:$includeClassification)\n      ...useContentClassification_content_4MZOe@include(if:$includeClassification),...PageContentRenderer_content,body{dynamic{representation,value,content{id,version{number}},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}},history@include(if:$includeAgentTrustReceiptData){createdDate,createdBy{__typename,displayName}}\n      contentProperties@include(if:$includeAgentTrustReceiptData){latest{generatedBy}},...ViewPageExtensionsAndRendererAssetsContentFragment_mediaContent@include(if:$includeRendererAssetsMedia),...ViewPageExtensionsAndRendererAssetsContentFragment_content@include(if:$isSSR)}},contentContributors(id:$contentId,limit:$bylineContributorsLimit)@include(if:$includeBylineContributors){...ByLineContributors_contentContributors,...NudgeContributorFilter_contentContributors,...SmartsFeedbackComponent_contentContributors,...PageHeaderLoomButton_contentContributors,isCurrentUserContributor},space(key:$spaceKey){id@include(if:$includeRendererAssetsCustomChrome)\n    settings@include(if:$includeRendererAssetsCustomChrome){customHeaderAndFooter{header{html,js,css,spaUnfriendlyMacros{name}},footer{html,js,css,spaUnfriendlyMacros{name}}}},...ContentHeader_space@include(if:$includeContentHeader),...ContentContainerTheme_space,...ContentTitle_space,...PageContentRenderer_space,id,theme{themeKey,name},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}},settings{routeOverrideEnabled},currentUser{isAnonymouslyAuthorized}}}fragment AnalyticsByLine_query_3SK5LQ on Query{contentAnalyticsViewers(contentId:$contentId){count},user:confluence_atlassianUser(current:true){id,confluence{permissionType}}}fragment ArchivedPageBannerV2Status_content on Content{id,status}fragment AudioContentFragment_content on Content{id,title,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},history{createdBy{__typename,displayName,profilePicture{path}},ownedBy{__typename,displayName,profilePicture{path}}},links{webui,base},audioProperties:properties(keys:[\"emoji-title-published\",\"editor\"]){nodes{value,key}}}fragment ByLineContributors_contentContributors on ContentContributors{count,isCurrentUserContributor,isOwnerContributor,nodes{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}}fragment ByLine_content_3gv61r on Content{...useReadTime_content,id,type,subType,history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},version{by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},contentProperties{latest{generatedBy}},...RendererContentState_content,pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{coverPictureWidth@include(if:$useNewContentTopper)}}}fragment BylineClassification_content_4MZOe on Content{id,title,type,status,operations{operation,targetType},space{id,name,key,alias},...useContentClassification_content_4MZOe}fragment ContentContainerTheme_space on Space{theme{name,themeKey},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}}}fragment ContentHeader_content_118EQH on Content{id,type,subType,title,status,metadata{lastModifiedDate,frontend{fabricEditorSupported}},...useFabricEligibilityMigrationQuery_content@include(if:$includeFabricEditorEligibility),...ContentTypesHeader_content,...EditContentButton_content,...useShareAndRestrictButtonData_content@include(if:$includeContentHeaderAccess)}fragment ContentHeader_space on Space{id,theme{themeKey}}fragment ContentModeFragmentProvider_content on Content{id,contentProperties{latest{contentMode},draft{contentMode}}}fragment ContentTitleWithByLine_content_2SjeOj on Content{...ContentTitle_content_2SjeOj,...ByLine_content_3gv61r,...ArchivedPageBannerV2Status_content,...MeetingNotesAutomationDiscoveryFragment_content}fragment ContentTitle_content_2SjeOj on Content{id,type,title,appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}},space{id,name,homepageId}}fragment ContentTitle_space on Space{id,theme{themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding}}}}fragment ContentTypesHeader_content on Content{id,title,operations{operation,targetType},space{id,name,key,alias},type,subType,status,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}}fragment CoverPictureQuery_content on Content{id,coverPictureProperties:properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}fragment EditContentButton_content on Content{id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType,space{id,key}}fragment MeetingNotesAutomationDiscoveryFragment_content on Content{id,title,body{dynamic{value}},metadata{sourceTemplateEntityId}}fragment NudgeContributorFilter_contentContributors on ContentContributors{isCurrentUserContributor}fragment PageContentRenderer_content on Content{id,title,type,status,version{confRev,number},metadata{lastModifiedDate},body{dynamic{representation,value,content{id,version{number}},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}}}fragment PageContentRenderer_space on Space{id,theme{themeKey}}fragment PageHeaderLoomButton_contentContributors on ContentContributors{isCurrentUserContributor}fragment PageStatusQueryRelaySpike_content on Content{status}fragment PresenterModePortal_content on Content{title,properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}}}fragment ReactionsContentFragment_content on Content{id,contentReactionsSummary{reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}fragment RendererContentState_content on Content{id,contentState(isDraft:false){id,name,color,restrictionLevel},contentStateLastUpdated(format:USER_FRIENDLY){value}}fragment SmartsFeedbackComponent_contentContributors on ContentContributors{isCurrentUserContributor}fragment ViewPageCommentsPanelPermission_content on Content{id,operations{operation,targetType}}fragment ViewPageExtensionsAndRendererAssetsContentFragment_content on Content{macroRenderedOutput{key,value{value,representation,webresource{tags{js,css}}}}}fragment ViewPageExtensionsAndRendererAssetsContentFragment_mediaContent on Content{id,body{atlas_doc_format{mediaToken{token}}}}fragment ViewPageLabelsContentFragment_content on Content{id,type,status,operations{operation,targetType},space{id},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count,nodes{__typename,id,label,name,prefix}}}fragment preloadAutohighlightsQuery_query_deyB3 on Query{knowledgeDiscovery{keyPhrases(entityAri:$autohighlightsEntityAri,workspaceId:$autohighlightsWorkspaceId)@optIn(to:\"KnowledgeDiscovery Get Key Phrases\"){__typename,...on KnowledgeDiscoveryKeyPhraseConnection{nodes{keyPhrase,category}},...on QueryError{message}}}}fragment useContentClassification_content_4MZOe on Content{id,classificationLevelDetails{classificationLevel@skip(if:$useClassificationLevelV2){id,guideline,guidelineADF,description,color,name,status},classificationLevelV2@include(if:$useClassificationLevelV2){id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}fragment useFabricEligibilityMigrationQuery_content on Content{id,metadata{frontend{fabricEditorEligibility,contentHash}}}fragment useReadTime_content on Content{id,type,body{dynamic{value,representation}},operations{operation,targetType}}fragment useShareAndRestrictButtonData_content on Content{id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title}fragment useTitleContentPropertiesForPublishedPage_content on Content{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}"
  }
};
})();

(node as any).hash = "b7f993b8bae654376c0716277fa66092";

export default node;
